import withLazyLoading from '../../hoc/withLazyLoading';
import { createCrumbHandle } from '../../utilities/auth';
import withPostHogTracker from '../../composeRouter';

const DashboardPage = withLazyLoading(() => import('../../pages/dashboardPage'));
const DashboardConfig = withLazyLoading(() => import('../../pages/dashboardConfig'));
const PageConfig = withLazyLoading(() => import('../../pages/pageConfig'));
const PageConfigV2 = withLazyLoading(() => import('../../pages/pageConfigV2'));
const DashboardPageList = withLazyLoading(() => import('../../pages/DashboardPageList'));
const UnifiedDashboardPage2 = withLazyLoading(() => import('../../pages/UnifiedDashboardPage2'));
const UnifiedDashboardPageList = withLazyLoading(() => import('../../pages/UnifiedDashboardPageList'));
const UnifiedPageConfig = withLazyLoading(() => import('../../pages/UnifiedPageConfig'));
const DnDUnifiedPageConfig = withLazyLoading(() => import('../../pages/DnDUnifiedPageConfig'));
const AIAnalysisConfig = withLazyLoading(() => import('../../pages/AIAnalysisConfig'));

const dashboardRoutes = [
    {
        path: '/dashboardConfig/:plantId',
        element: <DashboardConfig />,
        // authz-v2 TODO: DashboardPage_Configuration_WE — gate server-side / useCan at component level
        handle: createCrumbHandle('Dashboard Configuration')
    },
    // ---- Analytics Page ------
    {
        path: '/dashboardPage/:plantId',
        handle: createCrumbHandle('Dashboard'),
        children: [
            {
                index: true,
                element: withPostHogTracker(<DashboardPage />),
            },
            {
                path: 'pageConfigv2/:plantId/:pageId',
                element: <PageConfigV2 />,
                handle: createCrumbHandle('Dashboard Configuration')
            },
            {
                path: 'DashboardPageList/:plantId',
                element: withPostHogTracker(<DashboardPageList />),
                handle: createCrumbHandle('Dashboard Pages')
            }
        ]
    },
    // ------- Unified Dashboard -------
    {
        path: '/UnifiedDashboardPage/:pageId',
        handle: createCrumbHandle('Dashboard'),
        children: [
            {
                index: true,
                element: withPostHogTracker(<UnifiedDashboardPage2 />),
                // authz-v2 TODO: UnifiedDashboardPage_View_R — gate server-side / useCan at component level
            },
            {
                path: 'UnifiedDashboardPageList',
                element: withPostHogTracker(<UnifiedDashboardPageList />),
                // authz-v2 TODO: UnifiedDashboardList_Manage_AE — gate server-side / useCan at component level
                handle: createCrumbHandle('Dashboard Pages')
            },
            {
                path: 'UnifiedPageConfig/:pageId',
                element: <UnifiedPageConfig />,
                // authz-v2 TODO: UnifiedDashboardPage_Configuration_WE — gate server-side / useCan at component level
                handle: createCrumbHandle('Dashboard Configuration')
            },
        ]
    },
    {
        // @has to remove it
        path: '/pageConfig/:plantId/:pageId',
        element: <PageConfig />,
        // loader:  validatePermission('Page_Config_A'),
        handle: createCrumbHandle('Dashboard Configuration')
    },
    {
        path: '/DnDUnifiedPageConfig/:pageId',
        element: <DnDUnifiedPageConfig />,
        // authz-v2 TODO: UnifiedDashboardPage_Configuration_WE — gate server-side / useCan at component level
        handle: createCrumbHandle('Dashboard Configuration')
    },
    {
        path: '/AIAnalysisConfig',
        element: <AIAnalysisConfig />,
        handle: createCrumbHandle('AI Analysis Configuration')
    },
];

export default dashboardRoutes;
